<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreOptions } from '@/composables/equipment/useEquipmentLookups';
import EquipmentSelect from './EquipmentSelect.vue';

const props = defineProps<{ allowAll?: boolean; disabled?: boolean }>();
const model = defineModel<string>({ required: true });

const { t } = useI18n({ useScope: 'global' });
const { stores } = useStoreOptions();

const options = computed(() => [
  ...(props.allowAll ? [{ value: '', label: t('equipment.allStores') }] : []),
  ...stores.value.map((store) => ({ value: store.id, label: store.name })),
]);
</script>

<template>
  <EquipmentSelect
    v-model="model"
    :options="options"
    :placeholder="t('equipment.chooseStore')"
    :disabled="disabled"
    :aria-label="t('equipment.fields.store')"
    icon="pi-shop"
  />
</template>
